import React, { useEffect, useState } from 'react';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { getAllNurseOrgList } from 'nursd-dashboard/api/organizationTable';
import { Card, Col, Row } from 'react-bootstrap';
import AnnouncementTable from './table/AnnouncementTable';

const Announcement = () => {
  const [options] = useState(['LPN', 'HHA', 'CNA', 'RN']);

  const [followers, setFollowers] = useState([]);
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [license, setLicense] = useState('All License');
  const [searchText, setSearchText] = useState('');

  const { authToken, location, organization } = useAuth();

  const getWeather = async primaryState => {
    const API_KEY = '60e15448320d2913356dc3e37fd4abf4';
    const URL = `https://api.openweathermap.org/data/2.5/weather?q=${primaryState}&appid=${API_KEY}`;

    try {
      const response = await fetch(URL);
      const data = await response.json();
      return data; // Explicitly return the data here
    } catch (err) {
      console.error(err);
      return null; // Return null in case of an error
    }
  };

  const getNurse = async () => {
    setLoadingScreen(true);
    try {
      const cusList = await getAllNurseOrgList(
        authToken,
        location,
        organization
      );

      const list = cusList.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );

      let array = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];

        let obj = {
          id: item.id,
          uniqueId: item.uniqueId,
          name: item.firstName + ' ' + item.lastName,
          profileImage: item.profileImage,
          primaryLicenseType: item.primaryLicenseType,
          nurseLoginControl: item?.nurseLoginControl,
          nurseAppAccessControl: item.nurseAppAccessControl,
          weather: await getWeather(item?.primaryState), // This should now return the weather data correctly
          mobileId: item?.mobileId, // This should now return the weather data correctly
          original: item
        };
        array.push(obj);
      }
      // console.log(array);
      if (list.length === array.length) {
        setFollowers(array);
        setLoadingScreen(false);
      }
    } catch (error) {
      setFollowers([]);
      setLoadingScreen(false);
    }
  };

  useEffect(() => {
    if (location !== '') {
      getNurse();
    }
  }, [authToken, location]);

  const filter = data => {
    return data?.filter(item =>
      item?.name?.toLowerCase().includes(searchText?.toLowerCase())
    );
  };

  return (
    <Card>
      <Card.Header className="bg-body-tertiary">
        <Row className="align-items-center g-1">
          <Col className="pe-0">
            <Row className="g-2">
              <Col>
                <h5 className="mb-0">
                  Nurse List (
                  {
                    filter(followers)?.filter(e =>
                      license === 'All License'
                        ? e
                        : license === 'HHA'
                        ? e?.primaryLicenseType === 'HHA'
                        : license === 'LPN'
                        ? e?.primaryLicenseType === 'LPN'
                        : license === 'CNA'
                        ? e?.primaryLicenseType === 'CNA'
                        : license === 'RN'
                        ? e?.primaryLicenseType === 'RN'
                        : e
                    )?.length
                  }
                  )
                </h5>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* <Row className="g-2 mt-2">
          <Col sm={2}>
            <Form.Control
              placeholder="Search by name..."
              onChange={e => setSearchText(e.target.value)}
              size="sm"
            />
          </Col> 
          <Col sm={2}>
            <Form.Select
              onChange={e => setLicense(e.target.value)}
              size="sm"
              value={license}
            >
              <option value="">All License</option>
              {options.map(option => (
                <option key={option}>{option}</option>
              ))}
            </Form.Select>
          </Col>
        </Row> */}
      </Card.Header>
      {location === '' ? (
        <div className="m-3">
          <p>Select Location Id</p>
        </div>
      ) : loadingScreen ? (
        <div className="m-3">
          <p>Loading...</p>
        </div>
      ) : followers?.length === 0 ? (
        <div className="m-3">
          <p>{location} - No Data Available</p>
        </div>
      ) : (
        <Card.Body className="bg-body-tertiary px-1 pb-1 pt-0 fs-10">
          {/* {viewType === 'card' ? (
                <Followers
                  data={filter(followers)?.filter(e =>
                    license === 'All License'
                      ? e
                      : license === 'HHA'
                      ? e?.primaryLicenseType === 'HHA'
                      : license === 'LPN'
                      ? e?.primaryLicenseType === 'LPN'
                      : license === 'CNA'
                      ? e?.primaryLicenseType === 'CNA'
                      : license === 'RN'
                      ? e?.primaryLicenseType === 'RN'
                      : e
                  )}
                  updateUser={updateUser}
                  updateUserSuspend={updateUserSuspend}
                  filter={filter}
                  license={license}
                  setShow={setShow}
                  setData={setData}
                />
              ) : ( */}
          <AnnouncementTable
            data={filter(followers)?.filter(e =>
              license === 'All License'
                ? e
                : license === 'HHA'
                ? e?.primaryLicenseType === 'HHA'
                : license === 'LPN'
                ? e?.primaryLicenseType === 'LPN'
                : license === 'CNA'
                ? e?.primaryLicenseType === 'CNA'
                : license === 'RN'
                ? e?.primaryLicenseType === 'RN'
                : e
            )}
            license={license}
            options={options}
            setSearchText={setSearchText}
            setLicense={setLicense}
          />
          {/* )} */}
        </Card.Body>
      )}
    </Card>
  );
};

Announcement.propTypes = {};

export default Announcement;
